/* eslint-disable max-len */

/* eslint-disable react/forbid-prop-types */

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/style-prop-object */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable no-prototype-builtins */

/* eslint-disable no-param-reassign */

/**
 * @author Shalini Jha
 * @name BulkUpload
 * @description A component that handles all the functions of bulk upload
 */
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import clsx from 'clsx';
import DrawerComponent from '../DrawerComponent';
import { CustomToolTip } from '../ToolTips';
import OngoingUploads from './OngoingUploads';
import RecentUploads from './RecentUploads';
import Message from '../Message';
import { BulkUploadStyle } from './overwriteStyle';
import styles from './BulkUpload.module.css';
import flatten from 'lodash/flatten';
import { loadLangCommon } from '../LocalizeLang';
import enData from './lang/en.json';
import esData from './lang/es.json';
import cmnData from './lang/cmn.json';
import frData from './lang/fr.json';
import { performDefaultValidations } from './BulkUploadValidations';
import axios from './../../axios';
import { MaterialUiCore, MaterialUiIcons, Moment } from '@gscope-mfe/common-libs';
import moment from 'moment-timezone';
import { AppUtils, Services, Utilities, GscopeMfeTools } from '@gscope-mfe/app-bridge';
const { withStyles } = MaterialUiCore,
    { FormControl } = MaterialUiCore,
    { InputLabel } = MaterialUiCore,
    { Select } = MaterialUiCore,
    { MenuItem } = MaterialUiCore,
    { bulkUpload } = Services,
    InfoOutlinedIcon = MaterialUiIcons.InfoOutlined,
    ErrorOutlineOutlinedIcon = MaterialUiIcons.ErrorOutlineOutlined,
    CloseOutlinedIcon = MaterialUiIcons.CloseOutlined,
    CheckCircleOutlineIcon = MaterialUiIcons.CheckCircleOutline,
    { convertMapToList, csvToObjArray, objArrayToCSV, generateRandomKey } = Utilities;
export const style = () => BulkUploadStyle;
/**
 * @name checkIfFileExists Validates whether a file has already been uploaded by the user
 * If the file exists it add a label  fileExists to be true
 * Else adds the file to the uploaded list
 * @param {Object} acceptedFiles
 * @param {Array} uploadedFiles
 */

export const checkIfFileExists = (acceptedFiles, uploadedFiles) =>
    uploadedFiles.reduce(
        (obj, file) => {
            if (obj[file.name]) {
                obj[file.name].fileExists = true;
                return obj;
            }

            return { ...obj, [file.name]: file };
        },
        { ...acceptedFiles },
    );
/**
 * @name removeFileExistFlag
 * @desc Sets the fileExists flag as false
 * @param {*} acceptedFiles
 */

export const removeFileExistFlag = (acceptedFiles) =>
    Object.keys(acceptedFiles).map((key) => {
        if (acceptedFiles[key].hasOwnProperty('fileExists')) {
            acceptedFiles[key].fileExists = false;
        }
        return acceptedFiles[key];
    });

const BulkUpload = ({ classes, openDrawer, handleClose, uploadHistory, updateUploadHistory, showTIDcolumn }) => {
    const defaultSelectValue = '---Please select---';
    const {
        bulkActions,
        serviceType,
        serviceAction,
        acceptFileTypes,
        sampleDownload,
        processor,
        additionalInputs,
        customParsingColumns,
        rowLimit = 10000,
        delimiterConfig,
        moduleLanguage = [],
        customParser,
        additionalData = {},
        useWasmProcessor,
    } = AppUtils.get().bulkUploadConfig;
    const { userInfo, setloading, marketConfig } = AppUtils.get();
    const [selectedUploadType, setSelectedUploadType] = React.useState(defaultSelectValue);
    const [acceptedFiles, setAcceptedFiles] = React.useState({});
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [successfulMessage, setSuccessfulMessage] = React.useState(null);
    const [multiLevelUploadOptions, setMultiLevelUploadOptions] = React.useState({});
    const [selectedSubUploadType, setSelectedSubUploadType] = React.useState(defaultSelectValue);
    const [selectedDelimiterConfig, setSelectedDelimiterConfig] = React.useState(delimiterConfig);
    const [valueSelected, setValueSelected] = React.useState(false);
    const [langArr, setLangArr] = React.useState([]);
    const langObject = { en: enData, es: esData, cmn: cmnData };
    const [optionsWithMultilevel, setOptionsWithMultilevel] = React.useState([]);
    const [optionsWithoutMultilevel, setOptionsWithoutMultilevel] = React.useState([]);
    React.useEffect(() => {
        moduleLanguage?.length
            ? setLangArr(moduleLanguage.map((lang) => [lang, langObject[lang]]))
            : setLangArr([
                  ['en', enData],
                  ['es', esData],
                  ['fr', frData],
                  ['cmn', cmnData],
              ]);
    }, []);
    const trans = loadLangCommon(langArr, 'bulkUpload');

    const getUploadOptions = () => {
        let optionsWithMultilevel = [];
        let optionsWithoutMultilevel = [];
        if (bulkActions) {
            optionsWithMultilevel = Object.keys(bulkActions).filter((item) =>
                bulkActions[item].hasOwnProperty('multilevelOptions'),
            );
            setOptionsWithMultilevel(optionsWithMultilevel);
            optionsWithoutMultilevel = Object.keys(bulkActions).filter((item) => !bulkActions[item].multilevelOptions);
            setOptionsWithoutMultilevel(optionsWithoutMultilevel);
        }
        return { optionsWithMultilevel, optionsWithoutMultilevel };
    };
    React.useEffect(() => {
        getUploadOptions();
    }, [bulkActions]);

    /**
     * @name updateUploadType
     * @param {String} value
     * @desc Gets the upload type for any upload
     */

    const updateUploadType = (value) => {
        const { optionsWithMultilevel } = getUploadOptions();
        const orderKey = optionsWithMultilevel.find((item) => bulkActions[item].hasOwnProperty('multilevelOptions'));
        if (
            bulkActions[orderKey] &&
            bulkActions[orderKey].multilevelOptions &&
            Object.keys(bulkActions[orderKey].multilevelOptions).length > 0
        ) {
            setMultiLevelUploadOptions(bulkActions[orderKey].multilevelOptions);
            setSelectedUploadType(value);
            setValueSelected(true);
        } else {
            setMultiLevelUploadOptions({});
        }
        if (value === defaultSelectValue) {
            setValueSelected(false);
        } else {
            setValueSelected(true);
        }

        setSelectedUploadType(value);
        setSelectedDelimiterConfig(bulkActions[value]?.delimiterConfig);
    };

    const isStride = GscopeMfeTools.getInfra() === 'stride';
    const getSampleFilePath = () => {
        if (sampleDownload && sampleDownload.fileName && sampleDownload.fileType) {
            const fileName = sampleDownload.fileName;
            const fileType = sampleDownload.fileType;
            let updatedServiceType = serviceType;
            let updatedServiceAction = serviceAction;

            // Check if serviceType and serviceAction are selected from dropdowns
            if (!updatedServiceType && !updatedServiceAction && selectedUploadType !== defaultSelectValue) {
                updatedServiceType = getServiceDetails(serviceType, 'serviceType');
                updatedServiceAction = getServiceDetails(serviceAction, 'serviceAction');
            }

            if (isStride) {
                return `/api/file/template/${fileName}/${fileType}?service=${updatedServiceType}&serviceAction=${updatedServiceAction}`;
            }
            return `/api/file/sample/${fileName}/${fileType}?service=${updatedServiceType}&serviceAction=${updatedServiceAction}`;
        } else {
            return `/api/file/bulk/template?service=${serviceType}&serviceAction=${serviceAction}`;
        }
    };

    /**
     * @name onDrop
     * @param {Array} files
     * @desc On drop handler for whenever user browses or drops a file
     * to the dropzone
     */

    const onDrop = (files) => {
        // On every drop remove the already existing label
        removeFileExistFlag(acceptedFiles);
        const uploadedFileList = checkIfFileExists(acceptedFiles, files);
        setAcceptedFiles(uploadedFileList); // moved processor function to submit button click function
    };
    /**
     * @name deleteFile
     * @param {String} fileName
     * @param {Object} fileList
     * @desc Deletes a file from the list
     */

    const deleteFile = (fileName, fileList) => {
        delete fileList[fileName];
        setAcceptedFiles({ ...fileList });
    };
    /**
     * @name getServiceDetails
     * @desc Gets the file action
     * @param {String} "serviceAction"/"serviceType"
     */

    const getServiceDetails = (action, type) => {
        if (action) {
            return action;
        }
        if (multiLevelUploadOptions && Object.keys(multiLevelUploadOptions).length > 0) {
            const multiLeveDetail = Object.keys(bulkActions).filter((item) =>
                bulkActions[item].hasOwnProperty('multilevelOptions'),
            );

            // Iterate over the orderKeys to find the correct multilevelOptions
            for (let key of multiLeveDetail) {
                if (bulkActions[key].multilevelOptions[selectedUploadType]) {
                    return bulkActions[key].multilevelOptions[selectedUploadType][type];
                }
            }

            // If no matching multilevelOptions found, fall back to the non-multilevel case
            if (bulkActions[selectedUploadType]) {
                return bulkActions[selectedUploadType][type];
            }
        }

        return bulkActions[selectedUploadType][type];
    };
    /**
     * @name getUploadedFiles
     * @desc Gets the list of all the uploaded files
     */
    /**
     * @name getUploadingFiles
     * @desc Gets the list of all the files that are currently uploading
     */

    const getUploadingFiles = () => {
        if (uploadHistory) {
            return uploadHistory.filter((file) => file.fileName && ['S', 'F', 'Q', 'P'].includes(file.status));
        }
        return [];
    };
    /**
     * @name uploadFile
     * @desc Triggers a request to upload a file
     * @param {Object} file
     */

    const uploadFile = (file) => {
        const formData = new FormData();

        if (file.processedCSV) {
            const csvBlob = new Blob([file.processedCSV], {
                type: 'text/csv;charset=utf-8',
            });
            const newFile = new File([csvBlob], file.name);
            formData.append('file', newFile);
            formData.append('originalFile', file);
        } else {
            formData.append('file', file);
        }

        formData.append('fileId', encodeURI(file.name));
        formData.append(
            'payload',
            JSON.stringify({
                userId: userInfo.loggedInUserName,
                fileName: encodeURI(file.name),
                service: getServiceDetails(serviceType, 'serviceType'),
                serviceAction: getServiceDetails(serviceAction, 'serviceAction'),
                buId: marketConfig.buId,
                martId: marketConfig.martId,
                additionalData:
                    !useWasmProcessor && !Object.keys(additionalData).length
                        ? undefined
                        : JSON.stringify({ ...additionalData, isWasm: useWasmProcessor }),
            }),
        );
        return bulkUpload(formData, useWasmProcessor);
    };

    function getTransactionId(item) {
        return Object.values(item.data).map((file) => file.payload.transactionId);
    }

    const handleProcessor = (files, callback) => {
        let count = 0;
        setErrorMessage(null);
        files.forEach((file) => {
            const reader = new FileReader();

            reader.onload = async () => {
                const originalCSVArray = csvToObjArray(reader.result);
                const { data, error } =
                    bulkActions && Object.keys(bulkActions).length > 0
                        ? await processor(originalCSVArray, selectedUploadType)
                        : processor(originalCSVArray);

                if (error) {
                    setErrorMessage(error);
                    setloading(false);
                    return;
                } else if (data?.length === 0 && originalCSVArray?.length === 0) {
                    setErrorMessage(`${file.name} ${trans('bulkUpload.incorrectFormat')}`);
                    setloading(false);
                } else {
                    if (customParser) {
                        acceptedFiles[file.name].processedCSV =
                            data?.length > 0
                                ? createCsvData(data, customParsingColumns)
                                : createCsvData(originalCSVArray);
                    } else {
                        acceptedFiles[file.name].processedCSV =
                            data?.length > 0
                                ? objArrayToCSV(data, customParsingColumns)
                                : objArrayToCSV(originalCSVArray);
                    }
                    setAcceptedFiles(acceptedFiles);
                    count++;

                    if (files.length == count) {
                        callback(acceptedFiles);
                    }
                }
            };

            reader.readAsText(file);
        });
    };

    function createCsvData(arrayData, sortedColumns) {
        if (!arrayData) {
            return;
        }
        var csvData = sortedColumns ? sortedColumns.join(',') : Object.keys(arrayData[0]);
        sortedColumns = csvData;
        csvData += '\n';

        for (var i = 0; i < arrayData.length; i++) {
            var row = arrayData[i];
            for (var j = 0; j < sortedColumns.length; j++) {
                if (typeof row[sortedColumns[j]] == 'object') {
                    row[sortedColumns[j]] = '"' + JSON.stringify(row[sortedColumns[j]]).split('"').join('""') + '"';
                }
                csvData += row[sortedColumns[j]];
                if (j == sortedColumns.length - 1) {
                    csvData += '\n';
                } else {
                    csvData += ',';
                }
            }
        }
        return csvData;
    }

    const handleUploadFile = (files) => {
        axios
            .all(files.map((file) => uploadFile(file)))
            .then(async (data) => {
                const successful = data.filter((item) => item.status === 200);
                if (successful.length < data.length) {
                    setErrorMessage(
                        `${trans('bulkUpload.failedToUpload')} ${data.length - successful.length} ${trans(
                            'bulkUpload.files',
                        )}`,
                    );
                }
                setSuccessfulMessage(`${successful.length} ${trans('bulkUpload.SuccessUpload')}`);
                await updateUploadHistory(flatten(successful.map(getTransactionId)));
                setloading(false);
                setAcceptedFiles({});
                setSelectedUploadType(defaultSelectValue);
            })
            .catch((err) => {
                setErrorMessage(err.toString());
                setloading(false);
            });
    };

    const modifyCSV = (file) => {
        const lineArr = file.split('\n');
        let newFile = '';
        const firstRow = lineArr[0].split(selectedDelimiterConfig.fileDelimiter);
        if (firstRow.length != selectedDelimiterConfig.columnCount) return file;
        else {
            for (let i = 0; i < lineArr.length; i++) {
                let currentLine = lineArr[i].split(selectedDelimiterConfig.fileDelimiter);

                for (let j = 0; j < currentLine.length; j++) {
                    let word = currentLine[j];
                    word = word.replace(/,/g, selectedDelimiterConfig.dataDelimiter);
                    newFile += word;

                    if (j < currentLine.length - 1) {
                        newFile += ',';
                    }
                }

                if (i < lineArr.length - 1) {
                    newFile += '\n';
                }
            }

            return newFile;
        }
    };

    const updateDelimiter = function (files, cb) {
        if (!selectedDelimiterConfig) {
            cb(files);
            return;
        }

        let count = 0;
        let modifiedFiles = [];
        files.forEach((file) => {
            const reader = new FileReader();

            reader.onload = () => {
                //modify file
                let resultVal = modifyCSV(reader.result); //create new csvFile

                const csvBlob = new Blob([resultVal], {
                    type: 'text/csv;charset=utf-8',
                });
                const newFile = new File([csvBlob], file.name);
                modifiedFiles.push(newFile);
                count++;

                if (count == files.length) {
                    cb(modifiedFiles);
                }
            };

            reader.readAsText(file);
        });
    };
    /**
     * @name handleUpload
     * @desc This functions triggers async calls to back-end
     * to upload files to the server
     */

    const handleUpload = async () => {
        if (!serviceType && !serviceAction && selectedUploadType === '---Please select---') {
            return;
        }
        setSuccessfulMessage(null);
        setErrorMessage(null);
        setloading(true);
        const files = convertMapToList(acceptedFiles);
        updateDelimiter(files, proceedUpload);
    };

    const proceedUpload = async (files) => {
        await performDefaultValidations(
            files,
            () => {
                if (processor && !useWasmProcessor) {
                    handleProcessor(files, function (updatedFiles) {
                        let updatedFilesList = convertMapToList(updatedFiles);
                        handleUploadFile(updatedFilesList);
                    });
                } else {
                    handleUploadFile(files);
                }
            },
            (message, errorFile) => {
                setloading(false);
                delete acceptedFiles[errorFile];
                setAcceptedFiles(acceptedFiles);
                setErrorMessage(
                    `${trans('bulkUpload.failedToUpload')}. We are not able to process files due to: ${message}`,
                );
            },
        );
    };
    /**
     * @name enableSubmitButton
     * @desc Enables the submit button based on the user selection
     */

    const enableSubmitButton = () => {
        if (bulkActions) {
            if (multiLevelUploadOptions && selectedUploadType !== defaultSelectValue) {
                return true;
            }

            if (multiLevelUploadOptions && selectedSubUploadType !== defaultSelectValue) {
                return true;
            }

            return false;
        }

        return true;
    };
    /**
     * @name cancelUpload
     * @desc Handles the cancel button feature
     */
    const cancelUpload = () => {
        //below line set the file list to empty/default on cancel upload.
        setAcceptedFiles({});
        setMultiLevelUploadOptions({});
        setSelectedUploadType(defaultSelectValue);
    };
    function RenderTitleWithStyle(string) {
        const keywords = ['Browse', 'parcourir', 'buscar'];
        const underlineWord = keywords.find((word) => string.includes(word)) || 'Browse';
        const parts = string.split(underlineWord);
        return (
            <>
                {parts[0]}
                <strong>
                    <u>{underlineWord}</u>
                </strong>
                {parts[1]}
            </>
        );
    }
    return (
        <DrawerComponent open={openDrawer} handleClose={handleClose} position="right" className={classes.root}>
            <div className={styles.bulkupload_custom}>
                <div className={styles.bulkUpload_header}>
                    <strong>{trans('bulkUpload.uploadFiles')}</strong>
                    <span className="sct-icon icon-Remove-18" fontSize="small" onClick={handleClose} />
                </div>
                {bulkActions && (
                    <FormControl variant="outlined" className={[classes.form, styles.select_fullWidth].join(' ')}>
                        {/* <InputLabel id="uploadType">{trans('bulkUpload.selectBulkType')}</InputLabel> */}
                        <strong className={styles.fifteenSize}>{trans('bulkUpload.selectBulkType')}</strong>
                        <Select
                            labelId="uploadType"
                            id="uploadType"
                            value={selectedUploadType}
                            className={styles.select}
                            onChange={(event) => {
                                setSuccessfulMessage(null);
                                setErrorMessage(null);
                                updateUploadType(event.target.value);
                                // You can also update serviceType and serviceAction here if necessary
                            }}
                            // labelWidth={200}
                        >
                            <MenuItem key="---Please select---" value="---Please select---">
                                ---{trans('bulkUpload.pleaseSelect')}---
                            </MenuItem>
                            {optionsWithMultilevel.map((item) => {
                                if (bulkActions[item] && bulkActions[item].multilevelOptions) {
                                    return Object.keys(bulkActions[item].multilevelOptions).map((option) => (
                                        <MenuItem key={`${item}-${option}`} value={option}>
                                            {trans(option)}
                                        </MenuItem>
                                    ));
                                }
                                return null; // Safeguard to return null if bulkActions[item] doesn't exist
                            })}
                            {optionsWithoutMultilevel.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {trans(item)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}

                {/* Drop Zone */}
                {!!bulkActions && selectedUploadType !== '---Please select---' ? (
                    <>
                        <div className={styles.bulkUpload_dropZoneContainer} id="dropZone">
                            <Dropzone onDrop={onDrop} accept={acceptFileTypes || '.csv'}>
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()} className={styles.bulkUpload_dropZone}>
                                        <input {...getInputProps()} />
                                        <span className="sct-icon icon-Upload" />
                                        <p className={styles.bulkUpload_content}>
                                            {RenderTitleWithStyle(trans('bulkUpload.title'))}
                                        </p>
                                        <div className={styles.bulkUpload_uploadLimit}>
                                            <span className={styles.bulkUpload_subContent}>
                                                {trans('bulkUpload.format', {
                                                    format: acceptFileTypes.split('.')[1] || 'csv',
                                                })}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </Dropzone>
                        </div>
                        <div className={styles.bulkUpload_downloadLink}>
                            <span className={styles.bulkUpload_subContent}>
                                {trans('bulkUpload.uploadLimitPhrase', {
                                    rowLimit: rowLimit.toLocaleString(),
                                })}
                            </span>
                            <a href={getSampleFilePath()} target="_self" id="bulkUploadSampleDownload">
                                {trans('bulkUpload.downloadSample')}
                            </a>
                        </div>
                    </>
                ) : (
                    ''
                )}
                {!bulkActions && (
                    <>
                        <div className={styles.bulkUpload_dropZoneContainer} id="dropZone">
                            <Dropzone onDrop={onDrop} accept={acceptFileTypes || '.csv'}>
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps()} className={styles.bulkUpload_dropZone}>
                                        <input {...getInputProps()} />
                                        <span className="sct-icon icon-Upload" />
                                        <p className={styles.bulkUpload_content}>
                                            {RenderTitleWithStyle(trans('bulkUpload.title'))}
                                        </p>
                                        <div className={styles.bulkUpload_uploadLimit}>
                                            <span className={styles.bulkUpload_subContent}>
                                                {trans('bulkUpload.format', {
                                                    format: acceptFileTypes.split('.')[1] || '.csv',
                                                })}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </Dropzone>
                        </div>
                        <div className={styles.bulkUpload_downloadLink}>
                            <span className={styles.bulkUpload_subContent}>
                                {trans('bulkUpload.uploadLimitPhrase', {
                                    rowLimit: rowLimit.toLocaleString(),
                                })}
                            </span>
                            <a href={getSampleFilePath()} target="_self" id="bulkUploadSampleDownload">
                                {trans('bulkUpload.downloadSample')}
                            </a>
                        </div>
                    </>
                )}
                {(Object.keys(acceptedFiles).length !== 0 ||
                    errorMessage ||
                    successfulMessage ||
                    (!!bulkActions && selectedUploadType !== '---Please select---') ||
                    !bulkActions) && (
                    <div className={styles.bulkUpload_fileContainer}>
                        <div className={styles.bulkUpload_isFileNotSelected}>
                            <strong className={styles.bulkUpload_files}>
                                {'File(s)'}
                                <CustomToolTip title={trans('bulkUpload.filesUpload')}>
                                    <InfoOutlinedIcon fontSize={'large'} />
                                </CustomToolTip>
                            </strong>
                        </div>
                        {Object.keys(acceptedFiles).length == 0 && !errorMessage && !successfulMessage && (
                            <CustomToolTip title={trans('bulkUpload.isFileNotSelected')}>
                                <span className={styles.bulkUpload_info_item}>
                                    <span className={styles.bulkUpload_info}>
                                        <InfoOutlinedIcon fontSize={'small'} />
                                        <span className={styles.bulkUpload_info_p}>
                                            {trans('bulkUpload.isFileNotSelected')}
                                        </span>
                                    </span>
                                </span>
                            </CustomToolTip>
                        )}
                        {errorMessage && (
                            <span className={styles.bulkUpload_info_item}>
                                <span className={styles.bulkUpload_error_Info}>
                                    <ErrorOutlineOutlinedIcon fontSize={'small'} />
                                    <CustomToolTip title={errorMessage}>
                                        <span className={styles.bulkUpload_info_p}>{errorMessage}</span>
                                    </CustomToolTip>
                                    <span
                                        className={styles.bulkUpload_info_closebtn}
                                        onClick={() => setErrorMessage(null)}
                                    >
                                        {' '}
                                        <CloseOutlinedIcon fontSize={'small'} />
                                    </span>
                                </span>
                            </span>
                        )}
                        {Object.keys(acceptedFiles).length == 0 && successfulMessage && (
                            <span className={styles.bulkUpload_info_item}>
                                <span className={styles.bulkUpload_success_Info}>
                                    <CheckCircleOutlineIcon fontSize={'small'} />
                                    <CustomToolTip title={successfulMessage}>
                                        <span className={styles.bulkUpload_info_p}>{successfulMessage}</span>
                                    </CustomToolTip>
                                </span>
                            </span>
                        )}
                        <div className={styles.bulkUpload_fileList}>
                            {Object.keys(acceptedFiles).length > 0 &&
                                Object.keys(acceptedFiles).map((file, index) => (
                                    <div className={styles.bulkUpload_file} key={generateRandomKey()}>
                                        <>
                                            <div
                                                className={clsx(
                                                    styles.bulkUpload_fileName,
                                                    acceptedFiles[file].fileExists
                                                        ? styles.bulkUpload_smFileName
                                                        : styles.bulkUpload_lgFileName,
                                                )}
                                            >
                                                <span>{`${index + 1}. `}</span>
                                                {acceptedFiles[file].name}
                                                <div className={styles.recentUploads_timeStamp}>
                                                    {`Last Update: ${moment(acceptedFiles[file].lastModifiedDate)
                                                        ?.tz(moment.tz.guess())
                                                        .format('MMM-DD-YYYY [at] hh:mm:ss a z')}`}
                                                </div>
                                            </div>
                                            {acceptedFiles[file].fileExists && (
                                                <CustomToolTip title={trans('bulkUpload.fileAlreadyExists')}>
                                                    <span
                                                        className={clsx(
                                                            'sct-icon icon-Warning-18',
                                                            styles.bulkUpload_warning,
                                                        )}
                                                    />
                                                </CustomToolTip>
                                            )}
                                        </>
                                        <div className={styles.bulkUpload_fileActions}>
                                            <CustomToolTip title={trans('bulkUpload.deleteFile')}>
                                                <span
                                                    className="sct-icon icon-Trash--Delete-181x"
                                                    onClick={() => deleteFile(acceptedFiles[file].name, acceptedFiles)}
                                                />
                                            </CustomToolTip>
                                        </div>
                                    </div>
                                ))}
                        </div>
                        {additionalInputs && additionalInputs}

                        {Object.keys(acceptedFiles).length > 0 && enableSubmitButton() && (
                            <div className={styles.bulkUpload_uploadAction}>
                                <button
                                    type="button"
                                    className={clsx('secondaryBtn secondaryBtnEnabled', styles.btnPadding)}
                                    id="cancel-button"
                                    onClick={cancelUpload}
                                >
                                    {trans('bulkUpload.cancel')}
                                </button>
                                <button
                                    type="button"
                                    className={clsx('primaryBtn', 'primaryBtnEnabled')}
                                    id="save-button"
                                    onClick={handleUpload}
                                >
                                    {trans('bulkUpload.submit')}
                                </button>
                            </div>
                        )}
                    </div>
                )}
                {/* Ongoing Uploads */}
                {/* {getUploadingFiles().length > 0 && <OngoingUploads fileList={getUploadingFiles()} trans={trans} />} */}
                {/* Uploaded Files */}
                {getUploadingFiles().length > 0 && (
                    <RecentUploads
                        files={uploadHistory}
                        showTIDcolumn={showTIDcolumn}
                        updateUploadHistory={updateUploadHistory}
                        trans={trans}
                    />
                )}
            </div>
        </DrawerComponent>
    );
};

BulkUpload.propTypes = {
    classes: PropTypes.shape({}).isRequired,
    openDrawer: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    uploadHistory: PropTypes.array.isRequired,
    updateUploadHistory: PropTypes.func.isRequired,
};
export default withStyles(style)(BulkUpload);
export { BulkUpload };
